// Sticky header background on scroll
const header = document.getElementById('siteHeader');
if (header) {
  const onScroll = () => {
    if (window.scrollY > 8) header.classList.add('scrolled');
    else header.classList.remove('scrolled');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

// Mobile nav toggle
const navToggle = document.getElementById('navToggle');
const mainNav = document.getElementById('mainNav');
if (navToggle && mainNav) {
  navToggle.addEventListener('click', () => {
    const open = mainNav.classList.toggle('open');
    navToggle.classList.toggle('active', open);
    navToggle.setAttribute('aria-expanded', String(open));
  });
  mainNav.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', () => {
      mainNav.classList.remove('open');
      navToggle.classList.remove('active');
      navToggle.setAttribute('aria-expanded', 'false');
    });
  });
}

// Dropdown nav items (click-toggle, works alongside CSS :hover)
document.querySelectorAll('.nav-link-toggle').forEach((btn) => {
  btn.addEventListener('click', (e) => {
    e.stopPropagation();
    const item = btn.closest('.nav-item');
    const isOpen = item.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', String(isOpen));
    document.querySelectorAll('.nav-item.is-open').forEach((other) => {
      if (other !== item) {
        other.classList.remove('is-open');
        other.querySelector('.nav-link-toggle')?.setAttribute('aria-expanded', 'false');
      }
    });
  });
});
document.addEventListener('click', () => {
  document.querySelectorAll('.nav-item.is-open').forEach((item) => {
    item.classList.remove('is-open');
    item.querySelector('.nav-link-toggle')?.setAttribute('aria-expanded', 'false');
  });
});

// Scroll-reveal for section content
const revealTargets = document.querySelectorAll(
  '.product-card, .feature-copy, .feature-media, .step, .review, .story-band .wrap > *'
);
revealTargets.forEach((el) => el.classList.add('reveal'));

if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  revealTargets.forEach((el) => observer.observe(el));
} else {
  revealTargets.forEach((el) => el.classList.add('is-visible'));
}

// Email signup popup — shows after a delay on every visit, reopens in success state after signup
const emailPopupOverlay = document.getElementById('emailPopupOverlay');
if (emailPopupOverlay) {
  const emailPopupClose = document.getElementById('emailPopupClose');
  const delaySeconds = parseInt(emailPopupOverlay.dataset.delay || '4', 10);
  const justSubscribed = window.__emailPopupJustSubscribed === true;

  const openPopup = () => {
    emailPopupOverlay.classList.add('is-open');
    emailPopupOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };
  const closePopup = () => {
    emailPopupOverlay.classList.remove('is-open');
    emailPopupOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  };

  if (justSubscribed) {
    openPopup();
  } else {
    setTimeout(openPopup, delaySeconds * 1000);
  }

  if (emailPopupClose) {
    emailPopupClose.addEventListener('click', closePopup);
  }
  emailPopupOverlay.addEventListener('click', (e) => {
    if (e.target === emailPopupOverlay) closePopup();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && emailPopupOverlay.classList.contains('is-open')) closePopup();
  });

  const emailPopupCopy = document.getElementById('emailPopupCopy');
  if (emailPopupCopy) {
    emailPopupCopy.addEventListener('click', () => {
      const code = emailPopupCopy.dataset.code;
      navigator.clipboard?.writeText(code).then(() => {
        const original = emailPopupCopy.textContent;
        emailPopupCopy.textContent = 'Copied!';
        setTimeout(() => { emailPopupCopy.textContent = original; }, 1800);
      });
    });
  }
}

// Product anatomy: layers drift apart as the section scrolls through view
if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  document.querySelectorAll('[data-anatomy-stack]').forEach((stack) => {
    const topLayer = stack.querySelector('.anatomy-layer-top');
    const bottomLayer = stack.querySelector('.anatomy-layer-bottom');
    const maxShift = 50;
    let ticking = false;

    const update = () => {
      const rect = stack.getBoundingClientRect();
      const vh = window.innerHeight;
      // Tracks the section's full pass through the viewport: fully together
      // when its center is at the bottom edge, fully apart when its center
      // reaches the top edge — and reverses continuously on scroll-up.
      const center = rect.top + rect.height / 2;
      const start = vh;
      const end = 0;
      let progress = (start - center) / (start - end);
      progress = Math.max(0, Math.min(1, progress));
      const shift = progress * maxShift;
      if (topLayer) topLayer.style.transform = `translateY(${-shift}px)`;
      if (bottomLayer) bottomLayer.style.transform = `translateY(${shift}px)`;
      ticking = false;
    };

    const onScroll = () => {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    };

    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);
  });
}
